module.exports = global["_"] = require("-!./underscore.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/underscore.js-exposed
// module id = 17
// module chunks = 15 16 17 18 19